import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: 1s;
`;
export const UserProfileDataSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PhotoAndNameContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;
export const ProfilePhoto = styled.img`
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin: 10px;
`;

export const NameAndCourseContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const UserDataContainer = styled.div`
  display: flex;
  flex-direction: column;

  & div {
    margin-top: 10px;
  }
`;
